<template>
  <div class="mallOrderList">
    <div class="tab">
      <div class="tabBody">
        <div
          @click="selectOrder(1)"
          :class="['item', { active: requestData.status == 1 }]"
        >
          待核销
        </div>
        <div
          @click="selectOrder(3)"
          :class="['item', { active: requestData.status == 3 }]"
        >
          已完成
        </div>
      </div>
    </div>
    <div class="listbody">
      <v-list
        :finished="finished"
        :finishedText="finishedText"
        @onLoad="onLoad"
        ref="list"
        :immediateCheck="immediateCheck"
      >
        <div
          class="order"
          v-for="(item, index) in listData"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="order-t">兑换时间：{{ item.insertTime }}</div>
          <div class="order-b">
            <div class="order-bl">
              <img :src="item.skuImageUrl" alt="" />
            </div>
            <div class="order-br">
              <div class="title">{{ item.changeTitle }}</div>
              <div class="price">{{ item.pointsChangeNum }}甜蜜值</div>
            </div>
          </div>
        </div>
      </v-list>
    </div>
  </div>
</template>

<script>
import { getOrderListUrl } from "./api.js";
import { getHashParam } from "@/utils/utils.js";
var moment = require("moment");
export default {
  name: "shopOrderList",
  data() {
    return {
      finishedText: "没有更多了",
      finished: false,
      requestData: {
        status: 1,
        curPage: 1,
        pageSize: 10,
      },
      listData: [],
      immediateCheck: true,
    };
  },
  components: {},
  destroyed() {},
  computed: {
    communityId() {
      return this.$store.state.communityId;
    },
    userId() {
      return this.$store.state.userId;
    },
    roomId() {
      return this.$store.state.houseId;
    },
    tenantId() {
      return this.$store.state.tenantId;
    },
  },
  mounted() {},
  methods: {
    selectOrder(status) {
      this.requestData.curPage = 1;
      this.listData = [];
      this.requestData.status = status;
      this.immediateCheck = true;
      this.getActivityList();
    },
    toDetail(item) {
      this.$router.push({
        name: "shopOrderDetail",
        query: { id: item.id },
      });
    },
    onLoad() {
      this.getActivityList();
    },
    getActivityList() {
      let params = {
        curPage: this.requestData.curPage++,
        pageSize: this.requestData.pageSize,
        status: this.requestData.status,
        userId: this.userId,
      };
      this.$axios.get(`${getOrderListUrl}`, { params: params }).then((res) => {
        console.log(res, 333);
        if (res.code === 200) {
          if (res.data.pages <= res.data.current) {
            this.finished = true;
          } else {
            this.$refs.list._data.loading = false;
          }
          this.finishedText = "没有更多了";
          if (res.data.records.length === 0) {
            this.finishedText = "";
            return;
          }
          res.data.records.forEach((item) => {
            if (item.skuImageUrl) {
              item.skuImageUrl = this.$handleImg(300, 300, item.skuImageUrl);
            }
            this.listData.push(item);
          });
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mallOrderList {
  min-height: 100%;
  background: #f9f9f9;
  .tab {
    // padding: 0 40px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    background: #ffffff;
    .tabBody {
      padding: 70px 0 36px;
      display: flex;
      font-size: 32px;
      font-weight: bold;
      color: #347eff;
      line-height: 44px;
      .item {
        flex: 1;
        font-size: 34px;
        line-height: 40px;
        text-align: center;
        color: #a3a3a3;
      }
      .active {
        position: relative;
        color: #347eff;
        &::after {
          position: absolute;
          left: 50%;
          bottom: -12px;
          transform: translateX(-50%);
          content: "";
          width: 34px;
          height: 6px;
          background: #347eff;
          border-radius: 3px;
        }
      }
    }
  }
  .listbody {
    padding-top: 146px;
  }
  .order {
    margin: 26px 28px 0 28px;
    background: #ffffff;
    box-shadow: 0px 4px 16px 0px rgba(225, 225, 225, 0.5);
    border-radius: 16px;
    .order-t {
      padding: 0 20px;
      line-height: 78px;
      font-size: 28px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      border-bottom: 2px solid rgba(0, 0, 0, 0.06);
    }
    .order-b {
      display: flex;
      padding: 22px;
      align-items: center;
      .order-bl {
        width: 180px;
        height: 180px;
        margin-right: 30px;
        background: #f6f6f6;
        text-align: center;
        border-radius: 16px;
        padding: 10px;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
          border-radius: 16px;
          vertical-align: middle;
        }
        &:after {
          content: "";
          display: inline-block;
          width: 0;
          height: 100%;
          vertical-align: middle;
        }
      }
      .order-br {
        font-size: 32px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 44px;
        .title {
          margin: 0px 0 8px 0;
        }
        .price {
          color: #347eff;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
<style lang="less">
.mallOrderList {
}
</style>
